import Link from 'found/Link';
import PropTypes from 'prop-types';
import React from 'react';

import BadgeActiveTimeRange from 'src/components/Badge/BadgeActiveTimeRange';
import Loading from 'src/components/Loading';
import UUID from 'src/components/UUID';

/**
 * Description
 * @param {object} props
 * @param {object} props.tariff
 * @returns {React.ReactElement} - AdminPropertyShowTariff component
 */
function AdminPropertyShowTariff({ tariff = null }) {
  if (!tariff) {
    return <Loading />;
  }

  const {
    uuid, identifier, title, active, meter,
  } = tariff;
  const { uuid: meterId, identifier: meterIdentifier } = meter;

  return (
    <tr>
      <th scope="row" colSpan={3}>
        <Link to={`/admin/tariffs/${uuid}`}>
          {title}
        </Link>
        <br />
        {identifier}
        <br />
        <UUID uuid={uuid} />
      </th>
      <td>
        <BadgeActiveTimeRange active={active} />
      </td>
      <td>
        <Link to={`/admin/meters/${meterId}`}>
          {meterIdentifier}
        </Link>
        <br />
        <UUID uuid={meterId} />
      </td>
    </tr>
  );
}

AdminPropertyShowTariff.propTypes = {
  tariff: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

export default AdminPropertyShowTariff;
